import React from 'react';
import { Marquee as Styled } from './styles';

/**
 *
 * This component is a fork of react-malarquee package
 * https://github.com/jasonslyvia/react-marquee
 *
 * This package did not fully meet our requirements so this is a simplified version
 *
 **/

export default class Marquee extends React.Component {

	container = React.createRef();

	state = {
		offset: 0
	};

	contentWidth = 0;
	containerWidth = 0;
	frameSkip = 0;
	skipRate = 2;
	moveRate = 100;

	componentDidMount() {
		this.measureContent();
		this.startAnimation();
		window.addEventListener('resize', this.measureContent);
	}

	componentWillUnmount() {
		this.stopAnimation();
		window.removeEventListener('resize', this.measureContent);
	}

	componentDidUpdate(prevProps) {
		if (this.props.children !== prevProps.children) {
			this.measureContent();
			this.startAnimation();
		}
	}

	animate = (lastStamp) => (curStamp) => {
		if (this.frameSkip === 0) {
			const timeDif = (curStamp - lastStamp) / 1000;
			let offset = this.state.offset - this.moveRate * timeDif;
			if (-offset >= this.contentWidth) {
				offset = offset % this.contentWidth;
			}
			offset = Math.round(offset);

			this.setState({ offset });
			this.frameSkip = this.skipRate;
		} else {
			this.frameSkip--;
		}

		// Make recursive call to animate to continue animation
		this.frameId = window.requestAnimationFrame(this.animate(curStamp));
	};

	startAnimation = () => {
		if (this.frameId || this.contentWidth <= this.containerWidth) {
			return;
		}
		this.frameId = window.requestAnimationFrame((timeStamp) => {
			this.frameId = window.requestAnimationFrame(this.animate(timeStamp));
		});
	};

	stopAnimation = () => {
		window.cancelAnimationFrame(this.frameId);
		this.frameId = null;
	};

	measureContent = () => {
		const container = this.container.current;
		const content = container.firstChild;
		const containerWidth = container.offsetWidth;
		const contentWidth = content.offsetWidth;

		if (this.containerWidth !== containerWidth || this.contentWidth !== contentWidth) {
			const prevWidth = this.containerWidth;
			this.containerWidth = containerWidth;
			this.contentWidth = contentWidth;

			if (this.contentWidth === 0) {
				this.stopAnimation();
			} else if (prevWidth === 0) {
				this.startAnimation();
			}
		}
	};

	content(state) {
		const style = {
			transform: `translateX(${state.offset}px)`
		};
		return <>
			<span style={style} key="l">
				{this.props.children}
			</span>
			<span style={style} key="r">
				{this.props.children}
			</span>
		</>;
	}

	render() {
		return <Styled
			onMouseEnter={this.stopAnimation}
			onMouseLeave={this.startAnimation}
			innerRef={this.container}
		>
			{this.content(this.state)}
		</Styled>;
	}
}
